<template>
	<v-container id="main-container" class="page-root pa-0 ma-0" fluid :style="{backgroundImage:'url('+bkImgSrc+')' }">
	</v-container>
</template>

<script>
	
	import pic from '../../assets/images/background.jpg';
	import {default as AuthUtil} from "../../util/auth.js";
	import {default as AuthApi} from "../../api/smp/auth/Auth.js";
	
	export default{
		name:"Main",
		data(){
		    return {
		        bkImgSrc:pic
		    }
		},
		methods:{
		},
		created(){
			let me = this;
			console.log("main created");	
			if(!AuthUtil.accessTokenExists()){				
				me.$router.push({path: '/login'});							
			}else{			
				me.$router.push({path: '/desktop'});										
			}			
					
		},
		beforeCreate(){
			console.log('before main created'); 
		}
		
	}
</script>

<style scoped>
	#main-container{
        position:absolute;
        /*
		background-image: url(${pic});
        background-image: url("../../assets/images/background.jpg");
        */
		background-size: cover;
		background-position: 50%;
	}
	
	.page-root{
		width:100%;
		height:100%;		
	}
</style>
